import { render, staticRenderFns } from "./SocialSignin.vue?vue&type=template&id=178e95db&scoped=true"
import script from "./SocialSignin.vue?vue&type=script&lang=js"
export * from "./SocialSignin.vue?vue&type=script&lang=js"
import style0 from "./SocialSignin.vue?vue&type=style&index=0&id=178e95db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178e95db",
  null
  
)

export default component.exports